// extracted by mini-css-extract-plugin
export default {"tabs":"F8-z","tablist":"G8-z","tablistItem":"H8-z"};